import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const DOORDASH_URL = 'https://www.doordash.com/store/tacos-y-pupusas-t%C3%ADa-sandra-denton-29965951'

function Header() {
  const { t, i18n } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)
  const { pathname } = useLocation()
  const onLanding = pathname === '/'

  const closeMenu = () => setMenuOpen(false)

  const handleLanguageToggle = () => {
    const current = (i18n.language || 'en').toLowerCase()
    i18n.changeLanguage(current.startsWith('es') ? 'en' : 'es')
    closeMenu()
  }

  // Anchor links target sections on the landing page. From /order they need to go home first.
  const anchor = (id) => (onLanding ? `#${id}` : `/#${id}`)

  return (
    <header className="site-header">
      <a href="#main-content" className="skip-link">{t('nav.skipToContent')}</a>
      <div className="header-inner container-wide">
        <Link to="/" className="site-name" onClick={closeMenu}>Tía Sandra</Link>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="primary-nav"
          aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span className="nav-toggle-bar" aria-hidden="true" />
          <span className="nav-toggle-bar" aria-hidden="true" />
          <span className="nav-toggle-bar" aria-hidden="true" />
        </button>

        <nav
          id="primary-nav"
          className={`primary-nav ${menuOpen ? 'is-open' : ''}`}
          aria-label="Main"
        >
          <ul className="nav-links">
            <li><a href={anchor('menu')} onClick={closeMenu}>{t('nav.menu')}</a></li>
            <li><a href={anchor('location')} onClick={closeMenu}>{t('nav.location')}</a></li>
            <li><Link to="/catering" onClick={closeMenu}>{t('nav.catering')}</Link></li>
            <li><a href={anchor('contact')} onClick={closeMenu}>{t('nav.contact')}</a></li>
          </ul>
          <div className="nav-actions">
            <Link
              to="/order"
              className="btn-primary nav-order-btn"
              onClick={closeMenu}
            >
              {t('nav.order')}
            </Link>
            <a
              href={DOORDASH_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary nav-doordash-btn"
              onClick={closeMenu}
            >
              {t('nav.doordash')}
            </a>
            <button
              type="button"
              className="lang-toggle"
              onClick={handleLanguageToggle}
              aria-label={t('nav.languageLabel')}
            >
              {t('nav.language')}
            </button>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
